/**
 * Removes trial CTAs from a links array (e.g. for `/lp2` pages).
 */
export const withoutTrialLinks = <T extends { action?: string }>(
  links: readonly T[],
): T[] => links.filter((link) => link.action !== 'trial');
